import MConverter from './index.vue';

export {
    MConverter,
};

export default MConverter;
